namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmSablonaKonvenceGordic extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmSablonaKonvenceGordicReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmSablonaKonvenceGordicObj & GContent;
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmSablonaKonvenceGordicObj());
            this.detailObj.createBase({
                contentName: "detailAdmSablonaKonvenceGordic",
                contentCaption: "jres:33000326",
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmSablonaKonvenceGordic", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
            //this.findFormRows("cesta-form-complete_row").gformrow("setLabel", )
            if (this.detailObj.isCestaString == false)
                this.detailObj.HideField("cesta-form-complete")
        }

        closing() {
            return this.detailObj.closeAction().done(() => { this.detailObj.removeTempFiles(); });
        }
    }


    export class DetailAdmSablonaKonvenceGordicObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmSablonaKonvenceGordicReadDto> {
        newVersion: boolean;
        private serviceCnt: GContent;
        private guids: string[];
        private extension: string;

        private nepovoleneZnakySoubor = ['<', '>', ':', '"', '/', '|', '?', '*', '_']
        private nepovoleneZnakyCesta = ['<', '>', ':', '"', '|', '?', '*']

        isCestaString = false;

        private getServiceCnt() {
            if (this.serviceCnt)
                return this.serviceCnt;
            return this.cnt.createServiceContent("Gordic.Adm.WebControls.DetailAdmSablonaKonvenceGordic");
        }

        create() {
            this.guids = [];
            
        }

        textPopis(): string | undefined | null {
            return "{0}\\{1}".format((this.data.cesta) ? this.data["cesta"] : "", (this.data.soubor) ? this.data["soubor"] : "")
        }

        setSxsDetail(): string {
            return "{1}_{2}#{0}#".format((this.data.cesta) ? this.data.cesta : "", (this.data.prefix) ? this.data.prefix : "", (this.data.soubor) ? this.data.soubor : "");
        }

        removeTempFiles() {
            this.getServiceCnt().fire("RemoveTempFiles", { guids: this.guids });
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmSablonaKonvenceGordicSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            this.getServiceCnt().call("ConvertFileToByte", { guid: data["file_guid"] }).done((arr) => {
                data.kopie = arr;
                if (this.options.newRecord == true) {
                    if (data.soubor)
                        data.soubor = "{0}.{1}".format(data.soubor, this.extension);
                    this.upsertAction(data, close);
                } else {
                    if (data.aktivita == 900 && data.kopie != null && data.kopie != undefined) {
                        this.cnt.dialogs.confirm("jres:33000257", "jres:33000638").on("yes", () => { //RC 33000638 : Aktivita záznamu je nastavena na 'zrušeno'. Přejete si z důvodu uvolnění prostoru v databázi odebrat i nahraný soubor?
                            data.kopie = null;
                            this.upsertAction(data, close);
                        })
                    } else 
                        this.upsertAction(data, close);
                }
                
            })
        }

        private upsertAction(data: Gordic.AdmIsl.Interface.GAdmSablonaKonvenceGordicSaveDto, close: boolean) {
            (this.cnt.isl.AdmSablonaKonvenceGordic.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase();
                    this.showSuccessSave(close);
                    if (close == true) {
                        this.closeAction(true).done(() => { this.cnt.close() });
                    } else
                        this.reloadDataBase();
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmSablonaKonvenceGordic", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): JQueryPromise<Gordic.Data.View<Gordic.Data.UnpackRow<any>>> {
            return this.cnt.isl.AdmSablonaKonvenceGordic.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.soubor) ? this.data.soubor : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                "actCopy*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actCopy: {
                    caption: "jres:33000639", //RC 33000639 : Zkopírovat
                    icon: "gi-copy",
                    tooltip: this.savePermissionObj.reason,
                    enabled: this.savePermissionObj.permission && !this.options.newRecord && this.newVersion == true,
                    run: (ev, ctx) => {
                        this.createCopyFrom();
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {
            if (editMode == true) {
                if (this.options.newRecord == true) {
                    this.cnt.findFields("cesta-form").gfield("enable");
                    this.cnt.findFields("soubor").gfield("enable");
                    //this.cnt.findFields("prefix-form").gfield("enable");
                }
                this.cnt.findFields("file").gfield("enable");
                if (this.newVersion == false && this.options.newRecord == false)
                    this.cnt.findFields("prefix").gfield("disable");
            }
            this.cnt.actions.actCopy?.update({ enabled: !editMode });
        }

        createForm() {
            var _this = this;
            if (this.options.newRecord == true) {
                this.form.addRow("jres:33000973").addField("gradio", { //RC 33000973 : Způsob zadání cesty
                    name: "zpusob-cesta",
                    initialValue: 1,
                    itemClass: "",
                    radios: [
                        { value: 1, label: "jres:33000974" }, //RC 33000974 : Po jednotlivých složkách 
                        { value: 2, label: "jres:33000975" } //RC 33000975 : Kompletní cesta
                    ],
                    change: (ev, ctx) => {
                        this.isCestaString = ctx.value == 2 ? true : false
                        if (this.isCestaString == true) {
                            this.HideField("cesta-form")
                            this.ShowField("cesta-form-complete")
                            this.cnt.findFields("cesta-form-complete").gfield("setValidators", [this.validatorCesta()])
                        } else {
                            this.HideField("cesta-form-complete")
                            this.ShowField("cesta-form")
                            this.cnt.findFields("cesta-form-complete").gfield("setValidators", [ ])
                        }
                    }
                })
                this.form.addRow({
                    label: "jres:33000327",
                    hint: "jres:33000976", //RC 33000976 : Jednotlivé složky oddělujte znakem \ (např. složka1\podsložka1\).
                    name: "cesta-form-complete_row"
                }).addField("gstringbox", {
                    name: "cesta-form-complete",
                    model: function (op, dto, opt) {
                        switch (op) {
                            case "collect":
                                if (_this.isCestaString == true) {
                                    var values = $(this).gfield("getValue");
                                    if (values) {
                                        dto["cesta"] = values;
                                        if (dto["cesta"].slice(-1) != "\\")
                                           dto["cesta"] += "\\"
                                    } else
                                        dto['cesta'] = "\\";
                                    break;
                                }
                        }
                    }
                })

                this.form.addRow({
                    label: "jres:33000327", //RC 33000327 : Cesta k souboru
                    name: "cesta-form_row"
                }).addField("gformbox", {
                    name: "cesta-form",
                    itemWidth: "",
                    itemTemplate: "{dir}",
                    disabled: true,
                    mode: "inlinesubmit",
                    form: this.formCestaGroups(),
                    multi: true,
                    dialogOptions: {
                        height: 100
                    },
                    model: function (op, dto, opt) {
                        switch (op) {
                            case "apply":
                                if (dto["cesta"]) {
                                    var cestaArray = new Array();
                                    dto["cesta"].split('\\').forEach((item) => {
                                        if (item != "")
                                            cestaArray.push({ dir: item })
                                    })
                                    $(this).gfield("setValue", cestaArray);
                                }
                                break;
                            case "collect":
                                if (_this.isCestaString == false) {
                                    var values = $(this).gfield("getValue");
                                    if (values) {
                                        dto["cesta"] = "";
                                        values.forEach((item) => {
                                            dto["cesta"] += "{0}\\".format(item["dir"].toUpperCase());
                                        })
                                    } else {
                                        dto['cesta'] = "\\";
                                    }
                                }
                                break;
                        }
                    }
                })
            } else {
                this.MakeField("cesta");
            }
            //if (this.options.newRecord == true) {
            //    this.form.addRow({
            //        label: "jres:33000329", //RC 33000329 : Prefixy
            //        name: "prefix-form_row"
            //    }).addField("gformbox", {
            //        name: "prefix-form",
            //        itemWidth: "",
            //        itemTemplate: "{prefix}",
            //        disabled: true,
            //        form: this.formPrefixGroups(),
            //        multi: true,
            //        mode: "inlinesubmit",
            //        dialogOptions: {
            //            height: 100
            //        },
            //        model: function (op, dto, opt) {
            //            switch (op) {
            //                case "apply":
            //                    //if (dto["prefix"]) {
            //                    //    var prefixArray = new Array();
            //                    //    dto["prefix"].split('-').forEach((item) => {
            //                    //        prefixArray.push({ prefix: item })
            //                    //    })
            //                    //    $(this).gfield("setValue", prefixArray);
            //                    //}
            //                    break;
            //                case "collect":
            //                    var values = $(this).gfield("getValue");
            //                    if (values) {
            //                        dto["prefix"] = "";
            //                        values.forEach((item) => {
            //                            dto["prefix"] += "{0}-".format(item["prefix"].toUpperCase());
            //                        })
            //                        if (dto["prefix"] != "")
            //                            dto["prefix"] = dto["prefix"].substring(0, dto["prefix"].length - 1);
            //                    } else
            //                        dto['prefix'] = "\\";
            //                    break;
            //            }
            //        }
            //    })
            //} else {
            //}
            this.MakeField("soubor", {
                validators: [new Gordic.Validators.Required({ stopping: true }), this.validatorName() ]
            });
            this.form.addRow({
                label: "jres:33000329", //RC 33000329 : Prefixy
                name: "prefix_row"
            }).addField("gstringbox", {
                name: "prefix",
                disabled: true
            })
            this.MakeField("popis");
            this.form.addRow({
                label: "jres:32000154",
                name: "row_file"
            }).addField("gfilefield", {
                name: "file",
                disabled: true,
                validators: (this.options.newRecord == true) ? [new Gordic.Validators.Required({ stopping: true }), this.validatorName()] : [this.validatorExtension()],
                flag: (this.options.newRecord == true) ? "required" : null,
                acceptExtension: ".docx,.dotx",
                downloadOnDisabledField: true,
                fileUploaded: (ev, obj) => {
                    if (obj.fileInfo)
                        if (obj.fileInfo.guid)
                            this.guids.push(obj.fileInfo.guid);
                },
                model: function (op, dto, opt) {
                    switch (op) {
                        case "apply":
                            if (dto["file"]) {
                                $(this).gfield("setValue", dto["file"]);
                                _this.guids.push(dto["file"].guid);
                            }
                            break;
                        case "collect":
                            var value = $(this).gfield("getValue");
                            if (value.length > 0) {
                                dto["file_guid"] = value[0].guid;
                                _this.extension = value[0].filename.split('.').pop();
                            } else {
                                dto['file_guid'] = null;
                                _this.extension = "";
                            }
                            break;
                    }
                }
            })
            this.MakeSelectField("priz_spis", Gordic.Prefabs.Select.admWflcpri(), {
                model: "model.priz_spis=value.priz_spis",
                serverFilters: {
                    priz_spis: [0, 1]
                }
            })
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        private formCestaGroups(): Gordic.Forms.Form {
            return new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1, L-12-12-0, M-12-12-0, S-12-12-0" })
                .addRow("jres:33000328").addField("gstringbox", {
                    name: "dir",
                    validators: [new Gordic.Validators.Required({ stopping: true }), this.validatorName()],
                    flag: "required"
                 }) 
        }

        //private formPrefixGroups(): Gordic.Forms.Form {
        //    return new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1, L-12-12-0, M-12-12-0, S-12-12-0" })
        //        .addRow("jres:33000330").addField("gstringbox", { //RC 33000330 : Prefix
        //            name: "prefix",
        //            validators: [new Gordic.Validators.Required({ stopping: true }), this.validatorName()],
        //            flag: "required"
        //        }) 
        //}

        private validatorExtension(): Gordic.Validators.Base {
            var validator = new Gordic.Validators.Base({ message: "jres:33000331" }) //RC 33000331 : Rozdílné přípony souborů v názvu a v nahraném souboru. Záznam nelze uložit.
            validator.validate = (value, source) => {
                var mySouborName = this.cnt.findFields("soubor").gfield("getValue");
                var myUploadFile = this.cnt.findFields("file").gfield("getValue");
                var ext1 = "";
                var ext2 = "";
                if (mySouborName)
                    ext1 = mySouborName.split(".").pop();
                if (myUploadFile.length > 0)
                    ext2 = myUploadFile[0]["filename"].split(".").pop();
                else
                    return true;
                if (ext1 != "" && ext2 != "") {
                    if (ext1.toUpperCase() == ext2.toUpperCase())
                        return true;
                }
                return false;
            }
            validator.stopping = true;
            return validator;
        }

        private validatorName(): Gordic.Validators.Base {
            var validator = new Gordic.Validators.Base({ message: "jres:33000332".format(this.nepovoleneZnakySoubor.join(", ")) }) //RC 33000332 : Název obsahuje nedovolený znak.
            validator.validate = (value, source) => {
                if (value == null || value == "")
                    return true;
                var valid = true;
                this.nepovoleneZnakySoubor.forEach((item) => {
                    if ((value as string).indexOf(item) != -1)
                        valid = false;
                })
                return valid
            }
            validator.stopping = true;
            return validator;
        }

        private validatorCesta(): Gordic.Validators.Base {
            var validator = new Gordic.Validators.Base({ message: "jres:33000332".format(this.nepovoleneZnakyCesta.join(", ")) }) //RC 33000332 : Název obsahuje nedovolený znak.
            validator.validate = (value, source) => {
                if (value == null || value == "")
                    return true;
                var valid = true;
                this.nepovoleneZnakyCesta.forEach((item) => {
                    if ((value as string).indexOf(item) != -1)
                        valid = false;
                })
                return valid
            }
            validator.stopping = true;
            return validator;
        }

        private createCopyFrom() {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmSablonaKonvenceGordic", {
                currentFilter: this.options.currentFilter,
                gridRc: this.options.gridRc
            }], {
                ID: "DetailAdmSablonaKonvenceGordic",
                newRecord: false,
                copy: true,
                soubor: this.data.soubor,
                cesta: this.data.cesta
            })
        }
    }
}